<fcp-empty-state
    [imageSrc]="'assets/img/fcp_no_access.svg'"
    [header]="getTranslationKey('header') | translate"
    *ngLet="productAccessRight | async as accessRight"
>
    <div fcpEmptyStateDescription>
        <p>
            {{ getTranslationKey('description1') | translate }}
        </p>
        <p>
            {{ getTranslationKey('description2') | translate }}
        </p>
    </div>
    <div fcpEmptyStateActions>
        <button
            fcp-filled-button
            (click)="openAccessRequestWithNoteModal()"
            *ngIf="accessRight === AccessState.NotRequested"
        >
            {{ 'ORDER.EMPTY_STATE.CONNECT' | translate }}
        </button>
    </div>
</fcp-empty-state>
<fc-confirm-dialog
    [modalId]="requestCreateStoreModalId"
    title="BRANDS.CREATE_STORE_POPUP.HEADER"
    cancel="BRANDS.CREATE_STORE_OR_PROCEED_POPUP.DECLINE"
    accept="BRANDS.CREATE_STORE_POPUP.ACCEPT"
    confirmationQuestion="BRANDS.CREATE_STORE_OR_PROCEED_POPUP.AFFIRMATION"
    (onAccept)="openCreateStoreModal()"
    (onReject)="sendRequestWithoutStore()"
>
    {{ 'BRANDS.CREATE_STORE_POPUP.BODY' | translate }}
</fc-confirm-dialog>
<fc-request-access-modal
    [modalId]="requestAccessWithNoteModalId"
    [requestedProductTerms]="requestedProductTermsForModal"
    [brandId]="brand?._id"
    (accept)="connectWithNote($event)"
    (reject)="clearConnectionData()"
></fc-request-access-modal>

<fc-create-store-dialog
    [modalId]="createStoreModalId"
    (onReject)="openNoStoreModal()"
    (onAccept)="sendRequestWithStore()"
>
</fc-create-store-dialog>
